module.exports = __webpack_public_path__ + "f87931f224c37710efb7e869669431f9.png";